import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';

import { createProfileRequest } from '../../../requests/adminProfiles';
import { LinkBtn, Icon } from '../../../components';
import { sendAlert } from '../../../actions/utils';
import RoleForm from './RoleForm';
import basicProfile from '../../Role/role';

const RoleNew = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCreate = async role => {
    createProfileRequest({
      dispatch,
      params: snakeCaseKeys(role),
      formData: true,
      successCallback: response => {
        dispatch(sendAlert({ kind: 'success', message: 'Perfil creado con éxito' }));
        history.push(`/admin/roles/${response.data.id}`);
      }
    });
  };

  return (
    <>
      <Row className="mt-4 mb-4 align-items-center">
        <Col xs={1}>
          <LinkBtn variant="circle-dark" className="btn-circle mt-3" block to="/admin/roles">
            <Icon icon="chevron-back" />
          </LinkBtn>
        </Col>
        <Col>
          <h2 className="text-uppercase mb-0 mt-3">Nuevo Perfil</h2>
        </Col>
      </Row>
      <RoleForm profile={basicProfile} action="new" formRequest={handleCreate} />
    </>
  );
};

export default RoleNew;
